var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElectricalSafety1Icon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
    fill: "#F0B100"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8097_75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33337 13.1667C7.22298 13.1671 7.11475 13.1361 7.02126 13.0774C6.92776 13.0187 6.85284 12.9347 6.80519 12.8351C6.75754 12.7356 6.73912 12.6245 6.75208 12.5149C6.76503 12.4053 6.80882 12.3016 6.87837 12.2158L12.6534 6.26585C12.6967 6.21584 12.7557 6.18205 12.8208 6.17002C12.8858 6.15799 12.953 6.16844 13.0114 6.19964C13.0697 6.23084 13.1157 6.28095 13.1418 6.34174C13.1679 6.40253 13.1726 6.47039 13.155 6.53418L12.035 10.0458C12.002 10.1342 11.9909 10.2293 12.0027 10.3229C12.0145 10.4166 12.0488 10.5059 12.1028 10.5833C12.1567 10.6608 12.2286 10.724 12.3123 10.7675C12.396 10.8111 12.489 10.8337 12.5834 10.8333H16.6667C16.7771 10.833 16.8853 10.8639 16.9788 10.9226C17.0723 10.9813 17.1472 11.0653 17.1949 11.1649C17.2425 11.2645 17.2609 11.3755 17.248 11.4851C17.235 11.5948 17.1912 11.6985 17.1217 11.7842L11.3467 17.7342C11.3034 17.7842 11.2444 17.818 11.1793 17.83C11.1142 17.842 11.047 17.8316 10.9887 17.8004C10.9304 17.7692 10.8844 17.7191 10.8583 17.6583C10.8322 17.5975 10.8275 17.5296 10.845 17.4658L11.965 13.9542C11.9981 13.8658 12.0092 13.7707 11.9974 13.6771C11.9856 13.5835 11.9512 13.4941 11.8973 13.4167C11.8434 13.3392 11.7715 13.276 11.6878 13.2325C11.6041 13.189 11.5111 13.1664 11.4167 13.1667H7.33337Z",
    stroke: "white",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8097_75"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricalSafety1Icon);
export default __webpack_public_path__ + "static/media/electrical_safety_1_icon.64c1565daf7b38dd74d821edfdd9e131.svg";
export { ForwardRef as ReactComponent };